import BASE_API from '@/api/dataBase';
import { formatDate } from '@/utils';
// import ProjectApi from '@/api/purchaseSalesCenter/project.js';
export default {
  props: {
    isDisabledPricingRule: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      companyList: [],
      departmentList: [],
      baseFormData: {
        isDefault: null,
        isNotEndDate: null,
        version: null,
        businessType: '',
        contractCreateDate: '',
        contractNo: '',
        contractName: '',
        contractType: '',
        customerName: '',
        customerNo: '',
        projectInitiationNo: '',
        projectName: '',
        contractBusinessDepartment: '',
        contractBusinessDepartmentName: '',
        companyCode: '',
        companyName: '',
        signDate: '',
        contractValidStart: '',
        contractValidEnd: '',
        contractOperaterName: '',
        contractOperaterNo: '',
        // recyclingCompanyFileNo: '',
        // recyclingCompanyName: '',
        platformCompanyFileNo: '',
        platformCompanyName: '',
        isFixedPrice: '',
        pricingRule: '',
        contractCurrency: '',
        personChargeCode: '',
        personChargeName: '',
        receiptMethod: '',
        contractTotalAmount: '0',
        overShippedPercentage: '',
        shortShippedPercentage: '',
        performanceBondPayMethodCode: '',
        performanceBondPayMethodName: '',
        performanceBond: '',
        warrantyClause: '',
        purchaseQuantity: '',
        businessContractTotalAmount: null, // 多加一个字段
        isRestrict: null,
        settlementDate: null,
      },
      materialTypeList: [],
      companyList1: [], // 回收公司和平台公司
      // recyclingCompanyFileList: [], // 回收公司
      platformCompanyFileList: [], // 平台公司
    };
  },
  methods: {
    // 获取公司
    async _getCompanyApi() {
      console.log('获取公司', this.userInfo);
      let isEdit = this.$route.query?.isEdit;

      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        this.companyList = data.data?.personCompanyInfo.map((item) => {
          return {
            label: item.personCompanyName,
            value: item.personCompanyCode,
          };
        });
        // 如果当时是创建的时候就赋值
        if (isEdit == 'false' || !isEdit) {
          if (!this.userInfo.companyCode) {
            const contractBusinessCompanyNo = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyCode
              : null;
            const contractBusinessCompanyName = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyName
              : null;
            this.baseFormData = {
              ...this.baseFormData,
              contractBusinessCompanyNo,
              contractBusinessCompanyName,
            };
          } else {
            this.baseFormData = {
              ...this.baseFormData,
              contractBusinessCompanyNo: this.userInfo.companyCode,
              contractBusinessCompanyName: this.userInfo.companyName,
              companyCode: this.userInfo.companyCode,
              companyName: this.userInfo.companyName,
            };
          }
        }
        if (this.baseFormData.contractBusinessCompanyNo) {
          // 获取部门下拉
          this._getDepartmentByCompanyCodeApi(this.baseFormData.contractBusinessCompanyNo);
        }
      } else {
        console.error('获取公司失败');
      }
    },
    // 回收公司和平台公司
    async _getCompanyApi1() {
      const { data } = await this.$axios.get(
        `${BASE_API.LISTDATA_SERECHCOMPANY}/${this.userInfo.tenantCode}`
      );
      if (data.code == 0) {
        this.companyList1 = data.data;
      } else {
        console.error('获取公司失败');
      }
    },
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(companyCode) {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: companyCode,
      });
      if (data.code == 0) {
        this.departmentList = data.data?.personDepartmentInfo.map((item) => {
          return {
            label: item.personDepartmentName,
            value: item.personDepartmentCode,
          };
        });
        const currentId = this.$route.query.id;
        if (!currentId) {
          this.baseFormData = {
            ...this.baseFormData,
            contractBusinessDepartment: this.userInfo.departmentCode,
            contractBusinessDepartmentName: this.userInfo.departmentName,
          };
        }
      } else {
        console.error('获取部门失败');
      }
    },
    // 正常编辑的选中
    handleChange(row, field) {
      console.log(row, field, '行');
    },
    async getProjectByProjectNo(projectInitiationNo) {
      const { data } = await this.$axios.post('/sales/goodsTradeProject/purchaseContractPage', {
        projectInitiationNo,
      });
      if (data.code == 0) {
        const rowData = data.data[0];
        const platformtCompany = rowData.platformtCompany;
        const platformtCompanyName = rowData.platformtCompanyName;
        // const recyclingtCompany = rowData.recyclingtCompany;
        // const recyclingtCompanyName = rowData.recyclingtCompanyName;
        // this.splitRecyclingCompanyFile(recyclingtCompany, recyclingtCompanyName);
        this.splitPlatformtCompanyList(platformtCompany, platformtCompanyName);
      } else {
        console.error('根据项目号获取项目信息失败');
      }
    },
    // 切割回收公司
    splitRecyclingCompanyFile(recyclingtCompany, recyclingtCompanyName) {
      if (recyclingtCompany && recyclingtCompanyName) {
        const recyclingtCompanyList = recyclingtCompany.split(',');
        const recyclingtCompanyNameList = recyclingtCompanyName.split(',');
        this.recyclingCompanyFileList = recyclingtCompanyList.map((item, index) => {
          return {
            label: recyclingtCompanyNameList[index],
            value: item,
          };
        });
      } else {
        this.recyclingCompanyFileList = [];
      }
    },
    // 切割平台公司
    splitPlatformtCompanyList(platformtCompany, platformtCompanyName) {
      if (platformtCompany && platformtCompanyName) {
        const platformtCompanyList = platformtCompany.split(',');
        const platformtCompanyNameList = platformtCompanyName.split(',');
        this.platformCompanyFileList = platformtCompanyList.map((item, index) => {
          return {
            label: platformtCompanyNameList[index],
            value: item,
          };
        });
      } else {
        this.platformCompanyFileList = [];
      }
    },

    changeChecked(prop, val) {
      if (prop == 'isDefault') {
        if (val == '0') {
          //wumaoFix
          this.baseFormData = {
            ...this.baseFormData,
            liquidatedDamagesType: null,
            liquidatedFixedValue: null,
            liquidatedInterestRate: null,
            qualityGuaranteeDepositMethodCode: null,
            chargeFixedValue: null,
            chargeProportion: null,
            qualityGuaranteeDepositOverdue: null,
          };
        }
      }
    },
    // 表单中的数据切换
    async changeMethod({ prop, val }) {
      console.log(prop, val, '修改');
      if (prop == 'contractBusinessCompanyNo') {
        if (val) {
          await this._getDepartmentByCompanyCodeApi(val);
        }
        // 选择公司
        const currentItem = this.companyList.find((item) => item.value == val);
        this.baseFormData = Object.assign(this.baseFormData, {
          contractBusinessDepartment: '',
          contractBusinessDepartmentName: '',
          companyCode: val,
          companyName: currentItem?.label,
          contractBusinessCompanyNo: val,
          contractBusinessCompanyName: currentItem?.label,
        });
      } else if (prop === 'contractBusinessDepartment') {
        // 选择部门的时候
        const currentItem = this.departmentList.find((item) => item.value == val);
        this.baseFormData = Object.assign(this.baseFormData, {
          contractBusinessDepartment: val,
          contractBusinessDepartmentName: currentItem?.label,
        });
      } else if (prop == 'contractSalesmanNo') {
        // 业务员
        let rowData = (val && val[0]) || {};
        this.baseFormData = Object.assign(this.baseFormData, {
          contractSalesmanNo: rowData?.personName,
          contractSalesmanName: rowData?.personNo,
        });
      } else if (prop == 'contractCurrency') {
        this.baseFormData = Object.assign(this.baseFormData, {
          companyCurrency: val?.currencyCode,
          companyCurrencyName: val?.currencyName,
          contractCurrency: val?.currencyCode,
          contractCurrencyName: val?.currencyName,
        });
      } else if (prop == 'projectInitiationNo') {
        // 项目编号
        const rowData = (val && val[0]) || {};
        console.log(rowData, '数据');
        this.baseFormData = Object.assign(this.baseFormData, {
          projectInitiationNo: rowData?.projectInitiationNo,
          //wumaoFix
          projectName: rowData?.projectName,
          // recyclingCompanyFileNo: '',
          // recyclingCompanyName: '',
          // platformCompanyCode: '',
          // platformCompanyFileNo: '',
          // platformCompanyName: '',
        });

        this.baseFormData.platformCompanyFileNo = '';
        this.baseFormData.platformCompanyName = '';
        this.platformCompanyFileList = [];
        if (rowData) {
          // const recyclingtCompany = rowData?.recyclingtCompany;
          // const recyclingtCompanyName = rowData?.recyclingtCompanyName;
          const platformtCompany = rowData?.platformtCompany;
          const platformtCompanyName = rowData?.platformtCompanyName;
          // this.splitRecyclingCompanyFile(recyclingtCompany, recyclingtCompanyName);
          this.splitPlatformtCompanyList(platformtCompany, platformtCompanyName);
        }
      } else if (prop == 'customerName') {
        // 切换客户
        const rowData = (val && val[0]) || {};
        console.log(rowData?.partnerCode, rowData?.partnerZhName, '--客户名称-->>');
        this.baseFormData = Object.assign(this.baseFormData, {
          customerNo: rowData?.partnerCode,
          customerName: rowData?.partnerZhName,
        });
      } else if (prop == 'personChargeName') {
        const rowData = (val && val[0]) || {};
        console.log(rowData, '--客户名称-->>');
        this.baseFormData = Object.assign(this.baseFormData, {
          personChargeCode: rowData?.id,
          personChargeName: rowData?.personName,
        });
      } else if (prop == 'contractValidStart') {
        // 合同开始日
        if (this.baseFormData.contractValidEnd && val > this.baseFormData.contractValidEnd) {
          this.$message.error('开始时间不能大于结束时间');
          this.baseFormData.contractValidStart = '';
        }
      } else if (prop == 'contractValidEnd') {
        // 合同到期日
        if (this.baseFormData.contractValidStart && val < this.baseFormData.contractValidStart) {
          this.$message.error('结束时间不能小于开始时间');
          this.baseFormData.contractValidEnd = '';
        }
      } else if (prop == 'performanceBondPayMethodCode') {
        if (this.dictListMap.performance) {
          let label = this.dictListMap.performance.find((item) => item.value == val).label;
          console.log('bond', label);
          this.baseFormData.performanceBondPayMethodName = label;
        }
      } else if (prop == 'recyclingCompanyFileNo') {
        console.log('进来了', val);
        // 回收公司
        // this.baseFormData.recyclingCompanyFileNo = val;
        const item = this.recyclingCompanyFileList.find((item) => item.value == val);
        // this.baseFormData.recyclingCompanyName = item?.label;
        this.baseFormData = {
          ...this.baseFormData,
          recyclingCompanyFileNo: val,
          recyclingCompanyName: item?.label,
        };
      } else if (prop == 'platformCompanyFileNo') {
        // 回收编码
        // this.baseFormData.platformCompanyFileNo = val;
        const item = this.platformCompanyFileList.find((item) => item.value == val);
        // this.baseFormData.platformCompanyName = item?.label;

        this.baseFormData = {
          ...this.baseFormData,
          platformCompanyFileNo: val,
          platformCompanyName: item?.label,
        };
        this.$refs.formItem.clearValidate();
      } else if (prop == 'isRestrict') {
        this.$emit('isRestrict', val);
      } else if (prop == 'liquidatedDamagesType') {
        if (!val || val == '') {
          this.baseFormData = {
            ...this.baseFormData,
            liquidatedFixedValue: '',
            liquidatedInterestRate: '',
          };
        } else if (val == 'FIXED') {
          this.baseFormData = {
            ...this.baseFormData,
            liquidatedInterestRate: '',
          };
        } else if (val == 'RATE') {
          this.baseFormData = {
            ...this.baseFormData,
            liquidatedFixedValue: '',
          };
        }
      } else if (prop == 'qualityGuaranteeDepositMethodCode') {
        if (!val || val == '') {
          this.baseFormData = {
            ...this.baseFormData,
            chargeFixedValue: '',
            chargeProportion: '',
          };
        } else if (val == 'FIXED') {
          this.baseFormData = {
            ...this.baseFormData,
            chargeProportion: '',
          };
        } else if (val == 'RATE') {
          this.baseFormData = {
            ...this.baseFormData,
            chargeFixedValue: '',
          };
        }
      }
      // else if (prop == 'shortShippedPercentage') {
      //   if (
      //     !this.baseFormData.overShippedPercentage ||
      //     this.baseFormData.overShippedPercentage == '' ||
      //     this.baseFormData.overShippedPercentage == null||
      //     this.baseFormData.overShippedPercentage.length==1
      //   ) {
      //     if (val) {
      //       this.baseFormData.overShippedPercentage = val;
      //     }
      //   }
      // }
    },
    // 提交表单数据的时候验证
    validate(fn) {
      this.$refs.formItem.validate(fn);
    },
  },

  mounted() {
    console.log('mixinMountedAgain', this.$route.query?.isEdit);
    let isEdit = this.$route.query?.isEdit;
    if (isEdit == 'false' || !isEdit) {
      setTimeout(() => {
        this.baseFormData = Object.assign(this.baseFormData, {
          contractCreateDate: formatDate(new Date()),
          //默认货币
          companyCurrency: 'CNY',
          companyCurrencyName: '中国人民币（国际）',
          contractCurrency: 'CNY',
          contractCurrencyName: '中国人民币（国际）',
          settlementDate: '0',
          isNotEndDate: '1',
          // companyCode: this.userInfo.companyCode,
        });
        this.baseFormData.contractOperaterNo = this.userInfo.userCode;
        this.baseFormData.contractOperaterName = this.userInfo.personName;
        console.log('contractOperatorName', this.baseFormData.contractOperaterName);
      }, 700);
    }
    // 料型下拉框
    this.materialTypeList = this.dictListMap.materialType;
  },
  created() {
    this._getCompanyApi();
    this._getCompanyApi1();
  },
  watch: {
    isDisabledPricingRule: {
      handler(val) {
        console.log(val, '监听是否定价');
        this.baseFormData = {
          ...this.baseFormData,
          isFixedPrice: !val,
        };
      },
      immediate: true,
    },
  },
};
